import { render, staticRenderFns } from "./NeedsDetail.vue?vue&type=template&id=c2effe68&scoped=true"
import script from "./NeedsDetail.vue?vue&type=script&lang=js"
export * from "./NeedsDetail.vue?vue&type=script&lang=js"
import style0 from "./NeedsDetail.vue?vue&type=style&index=0&id=c2effe68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2effe68",
  null
  
)

export default component.exports